import { AfterContentInit, AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';


import { Chart } from 'chart.js';
import { TreemapController, TreemapElement } from 'chartjs-chart-treemap';

Chart.register(TreemapController, TreemapElement);


@Component({
  selector: 'app-tree-chart',
  templateUrl: './tree-chart.component.html',
  styleUrls: ['./tree-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class TreeChartComponent implements OnInit, AfterViewInit {
  @ViewChild('chartArea') private chartArea!: ElementRef<HTMLCanvasElement>;
  private chart: any;

  @Input() data: any;

  constructor() { }

  ngOnInit(): void {

  }

  getColor(value: any, legend: any): string {
    return this.colorFromRaw(value, legend);
  }

  findIndexInCategory(array: any, num: number): number {
    const sortedArray = array.slice().sort((a: any, b: any) => a - b);

    for (let i = 0; i < sortedArray.length; i++) {
        if (num <= sortedArray[i]) {
            return i;
        }
    }
    if (num > sortedArray[4]) {
    return 4;
    }

    return sortedArray.length; // If number is greater than all elements
}

  colorFromRaw(value: any, legend: any): string {
    const item = this.findIndexInCategory(legend, value);
    switch (item) {
      case 0:
        return '#e9ffdb';
      case 1:
        return '#d0f0c0';
      case 2:
        return '#ace1af';
        case 3:
        return '#a8e4a0';
        case 4:
        return '#008000';
      default:
        return '#e9ffdb';
    }
  }

  generateLegend(data: any): any[] {
    const totalCountArray = data.short_key.map((item: any) => item.total_count);
    const minValue: number =  Math.min(...totalCountArray);
    const maxValue: number =  Math.max(...totalCountArray);
    const step = (maxValue - minValue) / 5;
    const legend = [];

    for (let i = 0; i < 5; i++) {
        const value = minValue + step * i;
        legend.push(value.toFixed(2)); // Adjust the precision as needed
    }

    return legend;
}


  ngAfterViewInit(): void {
    const canvasCtx = this.chartArea.nativeElement.getContext('2d');
    if (!canvasCtx) {
      return;
    }

    const tree = this.data.short_key.map((item: any) => ({ value: item.total_count, what: item.question_label, unit: item?.value_format}));
    const unitValue = this.data.short_key.length ? this.data.short_key[0]?.value_format : '';

    const legend: any = this.generateLegend(this.data);

    const config = {
      type: 'treemap',
      data: {
        datasets: [
          {
            label: '',
            tree,
            key: 'value',
            groups: ['what'],
            borderWidth: 0,
            borderRadius: 6,
            spacing: 1,
            backgroundColor: (context: any) => {
              if (context.type !== 'data') {
                return 'transparent';
              }

              return this.getColor(context.raw._data.value, legend);
            },
            labels: {
              align: 'left',
              display: true,
              formatter(context: any): any {
                if (context.type !== 'data') {
                  return;
                }
                const valueUnit = context.raw.v + ' (' + context.raw._data?.children[0]?.unit + ')';
                return [...splitLabelToFit(context.raw._data.what, context.raw.v * 0.5, context), valueUnit] ;
              },
              color: ['black', 'black'],
              font: [{ size: 12, weight: 'bold' }, { size: 12 }],
              position: 'top'
            }
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false
          },
          datalabels: {
              display: false,
          },
          tooltip: {
            callbacks: {
              footer,
            }
          }
      }
      }
    };

    function footer(tooltipItems: any): string {
      const sum = 0;
      return unitValue ? '(' + unitValue + ')' : '';
    }

    function splitLabelToFit(label: string, maxWidth: number, context: any): string[] {
      const words = label.split(' ');
      const lines = [];
      let currentLine = '';
      for (const word of words) {
        const newLine = currentLine + ' ' + word;
        const width = context.chart.ctx.measureText(newLine).width;
        if (width < maxWidth) {
          currentLine = newLine;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }
      lines.push(currentLine);
      return lines;
    }


    this.chart = new Chart(canvasCtx, config as any);
  }
}
